import script from "./lyFormSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./lyFormSetting.vue?vue&type=script&setup=true&lang=js"

import "./lyFormSetting.vue?vue&type=style&index=0&id=6ed4b063&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed4b063"]])

export default __exports__